import { MLanguage } from 'vue-multilanguage';

export default new MLanguage('pt-br').create({
    // Header
    safeEnvironment: 'Ambiente',
    safeEnvironmentSuffix: ' 100% Seguro',

    //Footer
    developedBy: 'Desenvolvido por',
    securePayment: 'Pagamento seguro',

    // Link Info
    linkInfo: 'Enviou uma solicitação de pagamento',

    // Total Overview
    totalAmount: 'Valor total',
    delivery: 'Entrega',
    deliveryAddress: 'Endereço de entrega',
    payment: 'Pagamento',
    paymentDate: 'Data de pagamento',

    // Cart Overview
    purchaseSummary: 'Resumo da compra',
    productOrServiceDescription: 'Descrição do produto ou serviço',
    showDescription: 'Mostrar descrição',
    hideDescription: 'Esconder descrição',

    // Cart Items
    more: 'mais',
    showLess: 'exibir menos',
    seeAllItems: 'Ver todos os itens',
    hideItems: 'Esconder os itens',

    // Shipping Method Overview
    within2Hours: 'Em até 2 horas',
    withinOneBusinessDay: 'Em até 1 dia útil',
    withinAnyBusinessDays: 'Em até {0} dias úteis',
    free: 'Grátis',

    // Common
    of: 'de',
    off: 'de desconto',
    cartDiscount: 'Desconto no carrinho',
    discountOn: 'Desconto no',
    zipcode: 'CEP',
    street: 'Endereço',
    addressLine1: 'Linha de endereço 1',
    addressLine2: 'Linha de endereço 2 (Opcional)',
    number: 'Número',
    complement: 'Complemento',
    district: 'Bairro',
    city: 'Cidade',
    state: 'Estado',
    province: 'Província',
    cpf: 'CPF',
    cnpj: 'CNPJ',
    foreign: 'Estrangeiro',
    foreigner: 'Estado, província, distrito (sigla)',
    continue: 'Continuar',
    confirmPayment: 'Confirmar o pagamento',
    back: 'Voltar',
    cancel: 'Cancelar',
    thanks: 'Obrigado!',
    notAvailable: 'Não disponível',
    copyCode: 'Copiar código',
    retry: 'Tentar novamente',
    copied: 'Copiado',
    identityConfirmation: 'Confirmação de identidade',
    confirmIdentity: 'Confirmar identidade',

    // Address
    chooseYourState: 'Selecione seu estado',
    chooseYourProvince: 'Selecione sua província',
    forgotIt: 'Esqueci',

    // Shipping Type
    selectDeliveryType: 'Selecione o tipo de entrega',
    shippingAddressInfo: 'Informe o endereço para entrega',
    freight: 'Frete',
    freightDefined: 'Frete definido',

    // Change Payment Type
    chooseHowYouWantToPay: 'Escolha como quer pagar',
    orChooseOtherWays: 'ou escolha outras formas',
    otherPaymentMethods: 'Outras formas de pagamento',
    expressPayment: 'Pagamento expresso com cartão',

    // Personal Data
    personalDataSubtitle: 'Falta pouco! Insira seus dados antes de concluir',
    fullName: 'Nome Completo',
    email: 'E-mail',
    cellPhone: 'Celular',
    identity: 'Número do documento',
    identityC2P: 'CPF',
    billingAddress: 'Endereço de cobrança',
    termsPreffix: 'Li e aceito os',
    termsSuffix: ' termos e condição de uso',
    privacyPreffix:
		'Quero receber promoções personalizadas de parceiros comerciais da Cielo. Mais detalhes você encontra na',
    privacySuffix: ' Política de Privacidade',
    completePurchase: 'Concluir compra',
    sameAddressOption: 'Meu endereço de cobrança é o mesmo de entrega',

    // Billing Address
    nationalAddress: 'Endereço nacional',
    internationalAddress: 'Endereço internacional',
    national: 'Nacional',
    international: 'Internacional',

    // Card Payment
    paymentByCreditCard: 'Pagamento por cartão de crédito',
    paymentByDebitCard: 'Pagamento por cartão de débito',
    paymentByVoucherCard: 'Pagamento por cartão de alimentação / refeição',
    paymentByMultibenefits: 'Pagamento por cartão Multibenefícios',
    paymentByGooglePay: 'Pagamento por Google Pay',
    cardName: 'Nome',
    expiration: 'Vencimento',
    securityCode: 'Código de segurança',
    cardNameHolder: 'Nome do titular (como está no cartão)',
    cardNameHolderValidation: 'Nome como está no cartão',
    cardNumber: 'Número do cartão',

    // Payment Success
    paymentSuccessTitle: 'Seu pedido foi realizado com sucesso!',
    paymentSuccessDetail:
		'Obrigado por comprar com a loja {0}, parceira da Cielo! Você pode acompanhar o status do seu pagamento em nossa página de ',
    paymentSuccessButtonLabel: 'Consultar Pedidos',

    // Loggi Message
    loggiThanksMessage: 'Obrigado por comprar conosco ',
    loggiSuccessTitle:
		'Seu pedido foi realizado e estamos confirmando o pagamento.',
    loggiSuccessBody:
		'Em breve você reberá um SMS da Loggi, para acompanhar o trajeto do seu pedido. E todas as informações da sua compra foram enviadas no seu email:',
    requestNumber: 'Número do pedido',

    // Boleto Message
    boletoSuccessBody:
		'Para concluir sua compra faça o pagamento do boleto. O pagamento será aprovado em 1 ou 2 dias úteis.',
    barcode: 'Código de barras',
    openBoleto: 'Abrir boleto',

    // Pix Finalize
    pixSuccessBody:
		'Para concluir sua compra faça o pagamento Pix. O pagamento será aprovado na mesma hora.',
    qrcodeExplanation:
		'Você também pode pagar via QRCode. Basta escanear de outro aparelho de celular',
    paywithPixSuccessFooter: 'Pague com',
    advertisingPixSuccessFooter:
		'Disponíveis nas lojas Google Play e Apple Store',

    // Payment Methods
    creditCard: 'Cartão de crédito',
    creditCardText: 'Insira os dados do cartão',
    debitCard: 'Cartão de débito',
    debitCardText: 'Insira os dados do cartão',
    boleto: 'Boleto Bancário',
    pix: 'Pix',
    pixText: 'Pague instantaneamente',
    qrCodePay: 'Qr Code Crédito',
    qrCodePayText: 'Escaneie o QR Code',
    voucher: 'Alimentação / Refeição',
    qrCodeDebit: 'Qr Code Débito',
    qrCodeDebitText: 'Escaneie o QR Code',
    clickToPay: 'ClickToPay',
    multibenefits: 'Cartão multibenefícios',
    multibenefits2: 'Alimentação e Refeição',
    googlePay: 'Google Pay',
    applePay: 'Apple Pay',
    pixOpenFiance: 'Pix via Open Finance',
    paymentByPixOpenFinance: 'Pagamento por Pix Open Finance',
    pixTypePixText: 'Escaneie ou copie o código',
    pixTypeOpenFinanceText: 'Pague com seu banco',
    recommendedBadge: 'Recomendado',

    // Card Installments
    chooseInstallmentsNumber: 'Selecione a quantidade de parcelas',
    installmentsNumber: 'Quantidade de Parcelas',
    installmentsItem: '{quantity}x de R$ {installmentPrice} (sem juros)',
    installment: 'Parcelamento',
    installmentSupportText: 'Informe o número do cartão para verificar o valor das parcelas',

    // Popups
    addressSearchZipcode: 'Aguarde, estamos consultando seu CEP',
    addressZipcodeNotFound:
		'Não encontramos as informações de endereço baseado neste CEP, continue preenchendo os campos',
    addressUnderstood: 'Entendi',
    warning: 'Aviso',
    paymentProviderPurchaseError:
		'Houve um erro no processamento da sua compra',
    wait: 'Aguarde',
    unexpectedError: 'Houve um erro inesperado!',
    withoutMessage: 'Sem mensagem',
    qrCodeGenerationError:
		'Houve um erro ao gerar o qrcode para sua transação. Por favor, abra o link novamente e repita o processo de pagamento.',
    finalizingPaymentError: 'Erro ao finalizar pagamento',
    unknownPaymentError: 'Erro desconhecido ao finalizar pagamento',
    chooseYourState: 'Por favor, selecione o seu estado.',
    unableCalculateShippingCost:
		'Infelizmente não conseguimos calcular o valor do frete.',
    invalidExpirationDate: 'Data de vencimento inválida',
    processingRequestError: 'Erro ao processar solicitação',
    cardBrandNotSupported: 'Bandeira do cartão não suportada',
    applePayErrorTitle: 'Erro ao processar pagamento com Apple Pay',
    applePaySesssionError: 'Erro ao criar a sessão Apple Pay. Por favor, selecione outra forma de pagamento ou entre em contato com a loja.',
    applePayContactFieldError: 'Por favor, verifique se todos os dados pessoais e de endereço de cobrança do cartão estão corretamente cadastrados no seu dispositivo iOS e tente novamente.',
    applePayCompletePaymentError: 'Erro ao completar o pagamento com Apple Pay. Por favor, selecione outra forma de pagamento ou entre em contato com a loja.',
    applePayBillingContactError: 'Por favor, verifique se todos os dados de endereço de cobrança do cartão estão corretamente cadastrados no seu dispositivo iOS e tente novamente.',
    applePayShippingContactError: 'Por favor, verifique se todos os dados pessoais estão corretamente cadastrados no seu dispositivo iOS e tente novamente.',

    // message codes
    cardExpired:
		'Data de validade do cartão expirada. Por favor, escolha outro cartão',
    couldNotCalculateFreight:
		'Não foi possível calcular o valor do frete. Por favor, informe novamente seu CEP de entrega.',
    fillWithFullName: 'Preencha com seu nome completo',
    finalizePaymentError:
		'Não foi possível finalizar o pedido. Por favor, entre em contato com a loja.',
    indentifyInvalid: 'CPF/CNPJ Inválido',
    internationalBillingAddressIsNotEnabled:
		'Não é possivel enviar dados internacionais de cobrança',
    invalidCardNumber: 'Número do cartão inválido',
    invalidCheckoutCieloCard:
		'O Cartão Elo digitado não é um cartão de crédito válido para compras no Checkout Cielo.',
    invalidCvv: 'Código de segurança inválido.',
    invalidFlagForCardNumber:
		'A bandeira selecionada não é válida para o número de cartão informado',
    invalidFormZipcodeMandatory:
		'Formulário inválido. CEP de preenchimento obrigatório',
    orderAlreadyProcessedMessage: 'O seu pedido já está sendo processado.',
    pleaseInformHolder: 'Por favor informe o nome do titular completo',
    productRemovedOrNotFound:
		'O produto solicitado não foi encontrado ou não está mais disponível.',
    wrongOperationResultSafetyCheck:
		'Resultado da operação está errado (verificação de segurança)',
    openFinanceUrlIsNull: 'Por favor, tente novamente.',
    tryCreateNewLink: 'Por favor, procure a loja para gerar um novo link de pagamento.',

    // title message codes
    opsTitle: 'Oppsss!',
    openFinanceUrlIsNullTitle: 'Erro ao redirecionar para o banco',

    // mpi
    cardAuthenticationError:
		'Ocorreu um erro na autenticação. Por favor selecione outro cartão ou outra forma de pagamento.',
    notAuthenticableCardError:
		'Cartão não autenticável. Por favor selecione outro cartão ou outra forma de pagamento.',
    unexpectedAuthenticationError:
		'Ocorreu um erro inesperado na autenticação.Tente novamente ou selecione outra forma de pagamento.',
    flagDoesNotSupport:
		'Bandeira não suporta autenticação. Por favor selecione outro cartão ou outra forma de pagamento.',

    // qr code pay
    qrCodePayTitle: 'Pagamento por QR Code Pay',
    payWithQrCodeSuccessFooter: 'Pague com',
    mobileAppAvailable: 'Disponíveis nas lojas Google Play e Apple Store',
    qrCodePayExplanation:
		'Para concluir sua compra faça o pagamento escaneando o QR Code abaixo. Basta escanear de outro aparelho de celular.',

    // Order response overview
    customerName: 'Nome',
    orderNumber: 'Número do pedido',
    documentNumber: 'Documento',
    orderDate: 'Data do pedido',

    //ClickToPay Infos
    clickToPayText: 'Compras mais rápidas com seu cartão de crédito.',
    clickToPayCTAText: 'Sobre o Click to Pay',

    clickToPayModalTitle: 'Click to Pay',
    clickToPayModalDescriptionFlags: 'Uma forma de pagamento rápida e segura, compatível com Mastercard e Visa',
    clickToPayModalDescriptionProtectedInf: 'Mantenha suas informações protegidas',
    clickToPayModalDescriptionUseWorld: 'Use em lojas no mundo todo',
    clickToPayModalDescriptionSimplePayment:
		'Configure uma vez e faça pagamentos descomplicados no futuro',

    clickToPayNewCardFormHeader: 'Dados do cartão de crédito',
    clickToPayIdentityInfo:
		'As informações serão usadas pelo Click to Pay para validar sua identidade.',
    clickToPayLegalPersonInfo:
		'O Click to Pay não está disponível para pessoa jurídica. Se este for o seu caso, ',
    clickToPayChangePaymentMethodCTA: 'troque aqui a forma de pagamento.',

    clickToPayAllowCheckout1: 'Cadastrar minhas informações com a ',
    clickToPayAllowCheckout2: ' no Click To Pay para compras mais rápidas e seguras.',

    clickToPayRememberMe: 'Lembrar dos meus cartões nesse navegador.',
    clickToPayAgreementText1: 'Ao continuar, você concorda com os',

    clickToPayAgreementTerms: 'Termos da ',

    clickToPayAgreementText2: 'e entende que seus dados serão tratados de acordo com as',
    clickToPayAgreementPrivacyTerms: 'Normas de privacidade.',
    clickToPayAllowSaveCard: 'Salvar meu cartão no Click to Pay para compras rápidas e seguras.',
    clickToPaySaveYourCard: 'Salve seu cartão',
    clickToPayWithSavedCard: 'Pague com cartão salvo',

    otpTitle: 'Acesse seus cartões',
    otpDescriptionInsertCode: 'Insira o código de autenticação enviado pela',
    otpDescriptionToEmail: 'para o e-mail',
    otpWrongEmail: 'O e-mail está errado?',
    otpResendCode: 'Reenviar código',
    otpRememberMe: 'Lembrar dos meus cartões nesse navegador',
    otpInvalidCodeError: 'Código inválido. Reenvie o código ou tente novamente',
    otpInaccessibleError:
		'A conta está indisponível no momento. Tente novamente mais tarde',
    otpRetriesExceededError:
		'O número de retentativas foi excedido. Tente novamente mais tarde',
    otpUnknownError:
		'Não foi possível acessar essa conta. Tente novamente mais tarde',

    // ClickToPay Redesign
    paymentWithC2P: 'Pagamento com Click to Pay',
    accessYourSavedCards: 'Acesse seus cartões salvos',
    howC2PUses: 'Como o Click to Pay usa as minhas informações?',
    howC2PUsesTooltipText: 'Click to Pay irá utilizar o número do telefone e e-mail para verificar se existem cartões salvos. Um código pode ser enviado para o celular para que é você. Poderá existir cobrança por mensagem de texto.',
    addCard: 'Adicionar cartão',
    rememberCards: 'Lembrar dos cartões neste navegador',
    rememberCardsTooltipText1: 'Com o cartão salvo no navegador, você não passará pela verificação e conseguirá acessar seus cartões com rapidez e segurança no Click to Pay.',
    rememberCardsTooltipText2: 'Não recomendado salvar em dispositivos públicos ou compartilhados.',
    edit: 'Editar',
    c2pAgreementText: 'Ao continuar você aceita o cadastro do seu cartão junto ao Click to Pay.',
    c2pAgreementTerms: 'Termos e condições da ',
    and: 'e',
    c2pCardVerifying: 'Click To Pay está verificando se existem cartões salvos',
    finishPaymentTitle: 'Falta pouco! Insira seu CPF antes de concluir',
    yourPersonalData: 'Seus dados pessoais',


    // Checkout errors
    errorCheckoutHeading: 'Não foi possível continuar',
    errorCheckoutBody: 'Escolha outro cartão ou mude a forma de pagamento',

    //Contact view
    contactTitle: 'Dados de contato',
    chooseCountry: 'Selecione o país',
    selectCountry: 'Selecionar',
    errorOTPHeading: 'Erro ao validar dados',
    errorOTPBody: 'Escolha outra forma de pagamento ou tente novamente.',
    errorOTPCTA: 'Ok, entendi',

    //Personal view
    PersonalTitle: 'Dados pessoais',

    //Card list view
    cardListTitle: 'Cartões salvos no Click to Pay',
    enterYourDocument: 'Digite seu documento',
    chooseTheNumberOfInstallments: 'Escolha a quantidade de parcelas',
    chooseInstallmentsNumberV2: 'Quantidade de parcelas',
    areTheCardsNotYours: 'Os cartões não são seus?',
    showAllCards: 'Mostrar todos os cartões',
    hideCardList: 'Esconder lista de cartões',
    addNewCard: 'Adicionar novo cartão',
    locked: '(Bloqueado)',
    expired: '(Expirado)',
    lockedAndExpired: '(Bloqueado) (Expirado)',
    thisCardIsLocked: 'Este cartão está bloqueado.',
    thisCardIsExpired: 'Este cartão está expirado.',
    thisCardIsLockedAndExpired: 'Este cartão está bloqueado e expirado.',

    //Order status, invalid url and invalid order views
    orderStatus: 'Status do pedido',
    invalidUrlTitle: 'A página que você está procurando não existe',
    invalidUrlText: 'Verifique a digitação e tente novamente.',
    invalidOrderTitle: 'Serviço temporariamente indisponível',
    invalidOrderText: 'Infelizmente, não será possível prosseguir no momento. Por favor, tente novamente mais tarde.',
    update: 'Atualizar',
    paymentUnderReview: 'Pagamento em análise',
    paymentUnderReviewText1: 'A confirmação do pagamento é realizada após aprovação de {0}.',
    paymentUnderReviewText2: 'Acompanhe o status do pagamento em nossa página de ',
    paymentDenied: 'Pagamento negado',
    paymentDeniedText: 'Verifique os dados do cartão ou tente novamente usando outra forma de pagamento.',
    paymentApproved: 'Pagamento aprovado',
    paymentApprovedText: 'Você pagou {0}.',
    paymentSummary: 'Resumo do pagamento',
    paymentDate: 'Data do pagamento',
    paymentRefused: 'Pagamento recusado',
    idPayConfirmation: 'Para garantir a segurança da sua compra, precisamos da confirmação de identidade da pessoa titular do cartão usado na compra, em até 1 hora.',
    confirmationInProgress: 'Confirmação em andamento',
    idPayRedirectText: 'Por favor, aguarde alguns segundos enquanto processamos a confirmação da identidade.',
    openFinanceRedirectError: 'Ocorreu um erro',
    openFinanceRedirectErrorText: 'Não foi possível redirecionar você para o banco, mas você pode tentar realizar o pagamento novamente mais tarde.',
    changePaymentType: 'Trocar forma de pagamento',
    openFinanceInterrupted: 'Não foi possível fazer o Pix via Open Finance',
    openFinanceInterruptedText: 'A transação foi interrompida. Você pode selecionar outro banco, trocar a forma de pagamento ou tentar novamente mais tarde.',
    openFinanceWrongData: 'Seus dados de identificação estão divergentes',
    openFinanceWrongDataText: 'Confira seus dados pessoais para confirmar a transação ou troque a forma de pagamento.',
    openFinanceWaitingConfirm: 'Aguarde a confirmação do pagamento pelo seu banco em até 30 minutos.',
    openFinanceCancel: 'Quero cancelar o pagamento',
    openFinanceCancelModalTitle: 'Cancelamento de pagamento',
    openFinanceCancelModalText: 'Tem certeza de que deseja cancelar o pagamento? Esta ação não poderá ser desfeita.',
    openFinanceCancelModalConfirm: 'Sim, cancelar',
    paymentCanceled: 'Pagamento cancelado',
    paymentCanceledText: 'Seu pagamento foi cancelado com sucesso e não será debitado nenhum valor da sua conta.',
    employerNumber: 'CNPJ da loja',
    transactionId: 'ID da transação',

    //Pix Type View
    changePixTypeTitle: 'Opções Pix para pagamento',
    changePixTypeOpenFinanceInfo1: 'Com o Pix via Open Finance, seus pagamentos serão rápidos e seguros!',
    changePixTypeOpenFinanceInfo2: 'Você não precisará mais sair do checkout para ir até o banco pagar.',
    pixTypeFilterBank: 'De qual banco você quer pagar?',
    pixTypeSuggestions: 'Todos os bancos',
    pixTypeEmptySearchTitle: 'Banco não encontrado',
    pixTypeEmptySearch: 'Veja se o nome do banco está digitado corretamente, senão, ele pode não fazer parte da iniciativa Open Finance.',
    pixOFOrderReviewTitle: 'Banco selecionado',
    pixOFOrderReviewRedirectWarning1: 'Para concluir, vamos te redirecionar para ',
    pixOFOrderReviewRedirectWarning2: ', você precisa ter saldo lá.',
    pixOpenFinanceRedirect: 'Autorização de pagamento',
    pixOpenFinanceRedirectLoading1: 'Estamos concluindo seu pagamento na Cielo',
    pixOpenFinanceRedirectLoading2: 'Por favor, aguarde alguns instantes.',
    pixOpenFinanceSecurityRedirect: 'Este redirecionamento é feito de forma segura via Open Finance.',
    pixOpenFinancePayToday: 'Pagar hoje',
    pixOpenFinanceLoadingBanks: 'Carregando bancos',
    pixOpenFinanceGoNowToBank: 'Ir agora para',

    //CVVAlert
    securityCVV: 'Por motivos de segurança, digite seu CVV',
    send: 'Enviar',

    //V2 inputs
    inputCVV: 'CVV',
    inputCardHolderName: 'Nome como está no cartão',
    inputCardDueDate: 'Vencimento',
    titleViewCredCard: 'Pagamento com cartão de crédito',
    titleViewDebitCard: 'Pagamento com cartão de débito',
    titleViewQrCodeCred: 'Pagamento por QR Code crédito',
    titleViewVoucherCard: 'Pagamento com cartão de alimentação / refeição',
    titleViewMultibenefitsCard: 'Alimentação e Refeição',
    titleViewGooglePay: 'Pagamento com Google Pay',
    titleViewApplePay: 'Pagamento com Apple Pay',
    textViewMultibenefitsCard: 'Use com Multibenefícios',
    installmentsExplanationV2: 'Escolha a quantidade de parcelas',
    qrcodeExplanationV2: 'Você também pode pagar via QRCode. Basta escanear de outro aparelho de celular',
    whatPayment: 'Como você quer pagar?',
    orderReview: 'Revisão do pedido',
    pixDescription: 'Você também pode pagar via QRCode',
    qrcodeTitle: 'Para concluir seu pagamento escaneie o QR Code abaixo',
    qrcodeInstruction: 'Abra em uma nova aba do navegador o link da aceitação QR Code (carteiras digitais):',
    textInstructionPayment: 'Instruções para efetuar o pagamento',
    textInstructionPayment2: 'Utilize as carteiras digitais para pagamento:',
    numberCardError: 'Número do cartão inválido',
    dateMonthCardError: 'Mês inválido. Deve estar entre 1 e 12.',
    cardExpirationError: 'A data de vencimento deve ser futura.',
    new: 'Novo',
    yourDocumentNumber: 'Seu CPF',

    // Select Phone
    countryCode: 'Selecione o código do país',
    selectCountryCode: 'Código do país',

    // Select Document Type
    documentType: 'Selecione o tipo de documento',
    selectDocumentType: 'Escolha o tipo de documento',

    // Select Country
    country: 'Selecione o país',
    selectCountry: 'País',

    wrongFlowMultibenefitsError: 'Este parece ser um cartão de alimentação e refeição. Informe os dados do cartão de crédito.',
    verifyCardMultibenefitsError: 'Confira o número do seu cartão, verifique se é um cartão de alimentação e refeição Elo.',
    finishButtonQrCode: 'Gerar QR Code',
    finishButtonPix: 'Gerar código Pix',
    change: 'Trocar',
    changePayment: 'Trocar pagamento',

    //Accessibility
    altLogo: 'Logo da Cielo, com as letras C-I-E-L-O estilizadas em cinza e azul sobre um fundo branco.',
    altLangEn: 'Bandeira do Reino Unido, idioma inglês.',
    altLangEs: 'Bandeira da Espanha, idioma espanhol.',
    altLangBr: 'Bandeira do Brasil, idioma Português.',
    altPix: 'Imagen do QR Code Pix para escaneamento',
    altQrCode: 'Imagen do QR Code para escaneamento',
    ariaLangList: 'Lista de seleção de idiomas.',
    ariaShippingTypeList: 'Lista de seleção de tipos de entrega.',
    ariaPaymentTypeList: 'Lista de seleção de tipos de pagamento.',
    ariaSelectList: 'Lista de seleção de :',
    ariaOrderSummary: 'Resumo do pedido.',
    ariaSeeAllItems: 'Clique para exibir todos os items do pedido.',
    ariaShowDescription: 'Clique para expandir a descrição.',
    ariaShowOrderSummaryContent: 'Clique para expandir o resumo do pedido.',
    ariaCTANull: 'Botão sem ação.',
    ariaCTAC2P: 'Clique para selecionar o método de pagamento Click to Pay.',
    ariaCTAAboutC2P: 'Clique para saber mais sobre o Click to Pay.',
    ariaCTACloseOverlay: 'Clique para fechar o overlay.',
    ariaCTASelect: 'Clique para abrir o seletor de :',
});
